import './MissionStrip.css';

export default function MissionStrip() {
  return (
    <div className="mission-strip">
      <blockquote>
        &ldquo;Our mission is to create{' '}
        <span>long-term value</span> through operational excellence,
        innovation, and sustainable growth.&rdquo;
        <cite>Omega Six Holdings Limited</cite>
      </blockquote>
    </div>
  );
}
